module.exports = __webpack_public_path__ + "img/bg-login-page.77675be7.svg";